module.exports = {"already_rated":"You have already rated this entry.","thanks_for_rating":"Thank you very much for rating this entry."};